import { z } from 'zod/v4';

export const orphanedResourceSchema = z.object({
  id: z.number().min(1),
  name: z.string().min(1),
  vehicleId: z.string().nullable(),
});

export type OrphanedResource = z.infer<typeof orphanedResourceSchema>;
